// extracted by mini-css-extract-plugin
export default {"formSuccessPage":"FormSuccessPage_formSuccessPage__cHn+u","head":"FormSuccessPage_head__eafbQ","link":"FormSuccessPage_link__oU-hG"};